import { createContext, useContext, useEffect, useState } from 'react';
import { useFetch } from '../../../services/Requests/useFetch';

const options: RequestInit = {
  method: "GET"
}

const defaultSettings = {
  email: '',
  operatorEmail: '',
  imageReportEmail: '',
  activeHours: false,
  startTime: '07:00',
  stopTime: '20:00',
  Operating: false,
  Maintenance: true
};

interface LoadSettings {
  email: string;
  operatorEmail: string;
  imageReportEmail: string;
  activeHours: boolean;
  startTime: string;
  stopTime: string;
  Operating: boolean;
  Maintenance: boolean;
}

interface MaintenanceContextType {
  maintenanceModeEnabled: boolean;
  setMaintenanceModeEnabled: (auth: boolean) => void;
  canMaintain: boolean;
  setCanMaintain: (auth: boolean) => void;
}

const MaintenanceContext = createContext<MaintenanceContextType | undefined>(undefined);

export const MaintenanceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  
  const { state: loadState, get: loadSettings, abortRequest: loadAbort } = useFetch<LoadSettings>('/api/missions/load_settings', options);
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
          loadSettings();
          return () => {
              if (loadAbort) {
                  loadAbort();
              }
          };
      }, []);
  
  useEffect(() => {
      const { status, data } = loadState;
      if (status === 'fetched' && data) {
          setSettings(data);
          setMaintenanceModeEnabled(data.Maintenance)
      }
  }, [loadState]);

  const [maintenanceModeEnabled, setMaintenanceModeEnabled] = useState<boolean>(settings.Maintenance);
  const [canMaintain, setCanMaintain] = useState<boolean>(false)

  return (
    <MaintenanceContext.Provider value={{ maintenanceModeEnabled, setMaintenanceModeEnabled,canMaintain, setCanMaintain }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenanceMode = () => {
  const context = useContext(MaintenanceContext);
  if (context === undefined) {
    throw new Error('useMaintenanceMode must be used within an MaintenanceProvider');
  }
  return context;
};
